/**
 * Created by Phatbass on 21/02/16.
 */

'use strict';

// TODO: Add all urls
angular.module('far.models.rankSeason', [])
    .service('RankSeason', function ($log, $http) {
        var list = [];

        Object.defineProperty(this, 'list', {
            get: function () {
                list = [];

                $http.get(Routing.generate('api_discipline_get_discipline_rank_seasons'))
                    .then(function (response) {
                        response.data.forEach(function (item, index) {
                            if (index == 0) {
                                item.selected = true;
                            } else {
                                item.selected = false;
                            }

                            list.push(item);
                        });
                    }, function (response) {
                        $log.error(response);
                    });

                return list;
            }
        });

        this.new = function (data) {
            return new RankSeason(data);
        };

        function RankSeason(data) {
            angular.merge(this, data);

            Object.defineProperty(this, 'save', {
                enumerable: false,
                get: function () {
                    return function () {
                        var method = 'post',
                            url = Routing.generate('api_discipline_post_discipline_rank_season');

                        var data = angular.merge({}, this);

                        return $http[method](url, data);
                    }
                }
            });
        }
    });